import mixpanel from "mixpanel-browser";
import store from "@/store";

const isMixpanelActive = () => mixpanel.main;

export const mixpanelWrapper = {
  track: (eventName, properties) => {
    if (!isMixpanelActive()) return;

    // If user has not been identified, but is currently logged in, then identify before tracking.
    if (store.state.user?.id && mixpanel.main._flags?.identify_called === false) {
      mixpanel.main.identify(store.state.user.id);
    }

    mixpanel.main.track(eventName, properties);
  },
  identify: id => {
    if (!isMixpanelActive()) return;
    if (!id) return;

    mixpanel.main.identify(id);
  },
  reset: () => {
    if (!isMixpanelActive()) return;

    mixpanel.main.reset();
  },
};
